import {
  Channel,
  ChannelDto,
  BaseSavedSearch,
  MarketSavedSearchDto,
  NotificationChannels,
  SavedSearchInput,
} from "../model/model";

export class MarketMapper {
  static notificationChannelsDtoToModel(
    channels: ChannelDto[]
  ): NotificationChannels {
    return {
      [Channel.WEB]: channels.includes(ChannelDto.NC),
      [Channel.EMAIL]: channels.includes(ChannelDto.EMAIL),
      [Channel.PUSH]: channels.includes(ChannelDto.PUSH),
    };
  }

  static channelToDto(channel: Channel): ChannelDto {
    switch (channel) {
      case Channel.WEB:
        return ChannelDto.NC;
      case Channel.EMAIL:
        return ChannelDto.EMAIL;
      case Channel.PUSH:
        return ChannelDto.PUSH;
      default:
        throw new Error(`Unsupported channel ${channel}`);
    }
  }

  static notificationChannelsModelToDto(
    notifications: NotificationChannels
  ): ChannelDto[] {
    return Object.entries(notifications)
      .filter(([, enabled]) => enabled)
      .map(([channel]) => this.channelToDto(channel as Channel));
  }

  static dtoToModel({
    id,
    description,
    notifications,
  }: MarketSavedSearchDto): BaseSavedSearch {
    return {
      id,
      name: description,
      notifications: this.notificationChannelsDtoToModel(notifications),
    };
  }

  static modelToUpdateDto(
    { id, name, notifications }: BaseSavedSearch,
    { type, searchKey, parameters }: MarketSavedSearchDto
  ): MarketSavedSearchDto {
    return {
      id,
      description: name,
      notifications: this.notificationChannelsModelToDto(notifications),
      type,
      searchKey,
      parameters,
    };
  }

  static modelToCreateDto(
    { name, notifications }: Omit<BaseSavedSearch, "id">,
    { type, searchKey, parameters }: SavedSearchInput
  ): Omit<MarketSavedSearchDto, "id"> {
    return {
      description: name,
      notifications: this.notificationChannelsModelToDto(notifications),
      type,
      searchKey,
      parameters,
    };
  }
}
